module.exports = __webpack_public_path__ + "media/images/lb/252-7c4357f5e61ea2c2302b090ee1188deb.svg";